import img from '../../assets/images/logo_light.png'

export default {
  logoUrl: img,
}
